export enum ESupportedLinkTypes {
    kinescope = 'kinescope',
}
export enum ELinkSeparatingLine {
    kinescope = 'https://kinescope.io',
}
export const supportedLinkTypes = Object.values(ESupportedLinkTypes).map((item) => item);
